export const TimeLineMinZoom = 3600000 * 24 * 12; //day, 60 * 60 * 1000 (1 hour)
export const TimeLineMaxZoom = 42 * 86400 * 1000; //year

